import { Field, Label, Switch } from '@headlessui/react'
import { useEffect, useState } from 'react'

import cn from '@/utilities/cn'

type ToggleProps = {
  checked?: boolean
  disabled?: boolean
  className?: string
  boldHeaders?: boolean
  label?: string | JSX.Element
  description?: string
  onChange: (value: boolean) => void
}
export default function Toggle({
  label,
  boldHeaders = false,
  checked,
  className = '',
  onChange,
  description,
  disabled
}: ToggleProps) {
  const [enabled, setEnabled] = useState(checked)

  useEffect(() => {
    setEnabled(checked)
  }, [checked])

  const onToggle = (value: boolean) => {
    setEnabled(value)
    onChange(value)
  }

  return (
    <Field as="div" className={cn(className, 'flex')}>
      <div className="flex flex-col">
        {label && (
          <Label as="span" className="mr-3 w-auto text-sm">
            <span className={cn('font-medium text-zinc-900', { 'font-bold': boldHeaders })}>{label}</span>
          </Label>
        )}

        {description && <span className="mr-5 text-sm text-zinc-500">{description}</span>}
      </div>
      <Switch
        disabled={disabled}
        checked={enabled}
        onChange={onToggle}
        className={cn(
          enabled ? 'bg-brand-400' : 'bg-zinc-200',
          'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2'
        )}
      >
        <span
          aria-hidden="true"
          className={cn(
            enabled ? 'translate-x-5' : 'translate-x-0',
            'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
          )}
        />
      </Switch>
    </Field>
  )
}
